import { Component, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { HouseholdSidePanelComponent } from '@se-po/se-my-sportsengine-feature-household-side-panel'
import { HouseholdService } from '@se-po/shared-data-access-services'
import { EditPersonaModalComponent } from '@se-po/shared-feature-edit-persona-modal'
import { MergePersonaModalComponent } from '@se-po/shared-feature-merge-persona-modal'
import { RemovePersonaModalComponent } from '@se-po/shared-feature-remove-persona-modal'
import { UserProfile } from 'se-resource-types/dist/lib/CentralService/Households'

@Component({
  selector: 'se-po-household',
  templateUrl: './household.component.html',
  styleUrls: ['./household.component.scss'],
})
export class HouseholdComponent implements OnInit {
  @ViewChild('householdSidePanel') public householdSidePanel: HouseholdSidePanelComponent
  @ViewChild('editPersonaModal') public editPersonaModal: EditPersonaModalComponent
  @ViewChild('mergePersonaModal') public mergePersonaModal: MergePersonaModalComponent
  @ViewChild('removePersonaModal') public removePersonaModal: RemovePersonaModalComponent

  public otherProfiles: UserProfile[]
  public profiles: UserProfile[]
  public ready = false
  public selfProfile: UserProfile

  private _selectedPersonaId: number = null

  constructor(
    private householdService: HouseholdService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  public get selectedPersonaId(): number {
    return this._selectedPersonaId
  }

  public set selectedPersonaId(selectedPersonaId: number) {
    if (selectedPersonaId !== this.selectedPersonaId) {
      this._selectedPersonaId = selectedPersonaId
      this.setIdParam(this.selectedPersonaId || null)
    }
  }

  public ngOnInit(): void {
    let personaId: number
    if (this.route.snapshot.queryParams.id) {
      personaId = Number(this.route.snapshot.queryParams.id)
    }
    this.getHouseholdProfiles(personaId)
  }

  public getHouseholdProfiles(id?: number): void {
    const personaId = id || this.selectedPersonaId
    this.householdService.findMyProfiles()
      .subscribe(
        (profiles: UserProfile[]) => {
          if (!profiles) return

          this.profiles = profiles
          this.otherProfiles = profiles.filter(p => p.relationship === 'other')
          this.selfProfile = profiles.find(p => p.relationship === 'self')
          if (personaId) {
            const profile = this.profiles.find(p => p.persona.id === personaId) || null
            if (profile) {
              this.selectedPersonaId = profile.persona.id
            }
            else if (this.selectedPersonaId) {
              this.selectedPersonaId = null
            }
          }
          this.ready = true
        }
      )
  }

  public onChosen(p: UserProfile): void {
    if (this.selectedPersonaId !== p?.persona?.id) {
      this.selectedPersonaId = p.persona.id
    }
    else {
      this.selectedPersonaId = null
    }
  }

  public onEdit(p: UserProfile): void {
    this.editPersonaModal.open(p)
  }

  public onMerge([keepProfile, mergeProfile]: UserProfile[], description: string): void {
    this.mergePersonaModal.open(keepProfile, mergeProfile, description)
  }

  public onRemove(p: UserProfile): void {
    this.removePersonaModal.open(p)
  }

  public onPersonaEdit(personaId: number): void {
    // trigger getting an updated self across mySE if the self profile image was updated
    const profile = this.profiles.find(p => p.persona.id === personaId)
    if (profile.relationship === 'self' && profile.access === 'owner') {
      this.householdService.loadSelfPersona()
    }
    // the updated profile is a different model than the central service profiles,
    // so just grabbing household from endpoint again rather than remapping
    this.getHouseholdProfiles()
  }

  public onPersonaRemove(removedProfile: UserProfile): void {
    this.profiles = this.profiles.filter(p => p.id !== removedProfile.id)
    this.otherProfiles = this.otherProfiles.filter(p => p.id !== removedProfile.id)
    if (this.selectedPersonaId && this.selectedPersonaId === removedProfile.persona.id) {
      this.selectedPersonaId = null
    }
  }

  private setIdParam(id: number): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { id },
      queryParamsHandling: 'merge'
    })
  }
}
